import { toast } from "sonner";
import { ROUTES } from "../config/routes";
import { useLang } from "../i18n/LangContext";

// Returns anchor props for a configurable route. Unconfigured routes show a notice instead of navigating.
export const usePlaceholder = (key) => {
  const { t } = useLang();
  const { env, value } = ROUTES[key];
  const route = value?.trim();
  if (route) {
    const external = /^https?:\/\//i.test(route);
    return { href: route, "data-route": key, "data-route-configured": "true", ...(external ? { target: "_blank", rel: "noopener noreferrer" } : {}) };
  }
  return {
    href: `#route-${key}`,
    "data-route": key,
    "data-route-configured": "false",
    onClick: (e) => {
      e.preventDefault();
      toast(t.toast.title, { description: `${t.toast.body} ${env}` });
    },
  };
};
